import { NavLink, Outlet, Link } from "react-router-dom";
import { UserCircle, EnvelopeSimple, FileText, Buildings, Bell, ShieldCheck, ArrowLeft } from "@phosphor-icons/react";

const NAV = [
  { to: "/app/settings/profile", label: "Mon profil", icon: UserCircle, testid: "settings-nav-profile" },
  { to: "/app/settings/email", label: "Email & Signature", icon: EnvelopeSimple, testid: "settings-nav-email" },
  { to: "/app/settings/templates", label: "Modèles d'emails", icon: FileText, testid: "settings-nav-templates" },
  { to: "/app/settings/organization", label: "Organisation", icon: Buildings, testid: "settings-nav-org" },
  { to: "/app/settings/notifications", label: "Notifications", icon: Bell, testid: "settings-nav-notifications" },
  { to: "/app/settings/security", label: "Sécurité", icon: ShieldCheck, testid: "settings-nav-security" },
];

export default function SettingsLayout() {
  return (
    <div className="max-w-[1100px] mx-auto" data-testid="settings-layout">
      <Link to="/app" className="text-xs text-muted hover:text-fg flex items-center gap-1 mb-4"><ArrowLeft size={12} /> Retour à l'app</Link>
      <div className="flex flex-col md:flex-row gap-8">
        <aside className="md:w-60 shrink-0">
          <div className="overline mb-3">Réglages</div>
          <nav className="space-y-1">
            {NAV.map((n) => {
              const Icon = n.icon;
              return (
                <NavLink key={n.to} to={n.to} data-testid={n.testid}
                  className={({ isActive }) => `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors ${isActive ? "bg-surface-2 text-fg font-medium" : "text-muted hover:text-fg hover:bg-surface-2/50"}`}>
                  <Icon size={16} /> {n.label}
                </NavLink>
              );
            })}
          </nav>
        </aside>
        <main className="flex-1 min-w-0"><Outlet /></main>
      </div>
    </div>
  );
}
